import { GoogleMapInterface } from 'common/utils/Map';
import {
  MapMarker,
  MapMarkerLayer,
  OverlayProps,
} from '../types';

import clusterLayerCreator from './utils/clusterLayerCreator';
import markerLayerCreator from './utils/markerLayerCreator';

export class GoogleMarker implements MapMarker {
  private _map?: GoogleMapInterface;
  private _clickHandlers: MapMarkerLayer['onClick'][] = [];

  constructor(map?: GoogleMapInterface) {
    this._map = map;
  }

  addClickHandler(handler: MapMarkerLayer['onClick']) {
    this._clickHandlers.push(handler);
  }

  deleteClickHandler(handler: MapMarkerLayer['onClick']) {
    this._clickHandlers = this._clickHandlers.filter(clickHandler => clickHandler !== handler);
  }

  public setOverlayProps(props: OverlayProps) {
    if (this._map && this._map.overlay) {
      this._map.overlay.setProps(props);
    }
  }

  updateLayers(layers: MapMarkerLayer[] = []) {
    if (this._map && this._map.overlay) {
      this._map.overlay.setProps({
        layers: layers.map(layer => (
          layer.type === 'cluster'
            ? clusterLayerCreator(layer)
            : markerLayerCreator(layer)
        ))
      });
    }
  }

  deleteMarker() {
  }
}
